import React, { useState, useEffect } from 'react';
import { ArrowLeft, FileText, Download } from 'lucide-react';
import { lang } from '../../../utils/langs';
import ButtonPrimary from '../../atoms/ButtonPrimary/view';
import ButtonSecondary from '../../atoms/ButtonSecondary/view';
import LoadingView from '../../pages/loading/loading-view';
import { generateAccountingPdfBlob } from '../../../services/reports/pdfGenerator';
import './style.css';

/**
 * ReportDataView
 * A premium molecule to visualize accounting report data as a PDF preview.
 */
const ReportDataView = ({
    data,
    onDownloadExcel,
    onDownloadPdf,
    onBack
}) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loadingPdf, setLoadingPdf] = useState(false);

    useEffect(() => {
        if (!data) return;

        setLoadingPdf(true);
        let active = true;
        let localUrl = null;

        generateAccountingPdfBlob(data)
            .then(blob => {
                if (!active) return;
                if (blob) {
                    localUrl = URL.createObjectURL(blob);
                    setPdfUrl(localUrl);
                } else {
                    setPdfUrl(null);
                }
                setLoadingPdf(false);
            })
            .catch(err => {
                if (!active) return;
                console.error("Error generating preview PDF:", err);
                setPdfUrl(null);
                setLoadingPdf(false);
            });

        return () => {
            active = false;
            if (localUrl) {
                URL.revokeObjectURL(localUrl);
            }
        };
    }, [data]);

    if (!data) return null;

    return (
        <div className="report-data-container">
            {/* Dynamic Data Sections showing PDF preview */}
            <div className="report-data-sections">
                {loadingPdf ? (
                    <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                        <LoadingView />
                    </div>
                ) : pdfUrl ? (
                    <iframe
                        src={pdfUrl}
                        width="100%"
                        height="100%"
                        style={{ border: 'none', borderRadius: '8px', flex: 1, minHeight: '400px' }}
                        title="Vista Previa de Reporte"
                    />
                ) : (
                    <div style={{ padding: '40px', textAlign: 'center', color: 'var(--color-gray-100)' }}>
                        {lang('es', 'no_data_available') || 'Sin datos disponibles para previsualizar.'}
                    </div>
                )}
            </div>

            {/* Action Buttons using ButtonPrimary and ButtonSecondary Atoms */}
            <footer className="report-data-actions">
                <ButtonSecondary
                    icon={<ArrowLeft size={18} style={{ marginRight: '8px' }} />}
                    title={lang('es', 'back') || 'Volver'}
                    onClick={onBack}
                />
                <ButtonPrimary
                    icon={<FileText size={18} style={{ marginRight: '8px' }} />}
                    title={lang('es', 'download_pdf') || 'Descargar PDF'}
                    onClick={onDownloadPdf}
                />
                <ButtonPrimary
                    icon={<Download size={18} style={{ marginRight: '8px' }} />}
                    title={lang('es', 'download_excel') || 'Descargar Excel'}
                    onClick={onDownloadExcel}
                />
            </footer>
        </div>
    );
};

export default ReportDataView;
